module.exports = __webpack_public_path__ + "static/media/No_Host_Property_Approved.b33540da.png";